/* eslint-disable react-hooks/exhaustive-deps */

import React, { useEffect, useState } from "react";
import { EditModal, Input } from "../../../common";
import { getDateFromTimezone } from "./Cards";
import { APIEndpoint } from "../../../utils/axios";
import { formatDateByTimezone, truncateString } from "../../../utils/commonFunctions";
import usePermissions from '../../../utils/userPermissions';
import IrTopCards from "./renderers/IrTopCards";
import ExpandableTable from "../../../common/ExpandableTable";



const filters = {
  action: 4,
  collection: '',
  filterOperation: 'or',
  filters: [],
  limit: 50,
  page: 1,
  searchParam: ''
};

const itemTableHead = [
  { field: "productCat", headerName: "Category",minWidth:150,flex:1, },
  { field: "estimatedMeal", headerName: "Est.Meal",minWidth:150,flex:1, },
  { field: "uplift", headerName: "Uplift",minWidth:150,flex:1, },
  { field: "sales", headerName: "Sales",minWidth:150,flex:1, },
  { field: "wastage", headerName: "Wastage",minWidth:150,flex:1, },
  { field: "offload", headerName: "Offload",minWidth:150,flex:1, },
  { field: "crewHandover", headerName: "Crew Handover",minWidth:150,flex:1, },
  { field: "retrieval", headerName: "Retrievel",minWidth:150,flex:1, },
  { field: "variance", headerName: "Variance",minWidth:150,flex:1, },
];

export const InventoryReconciliation = () => {
  const [filterData, setFilterData] = useState({
    startDate: (()=>{
      const today = new Date();
      const pastDate = new Date(today).setDate(today.getDate()-60)
      return new Date(pastDate)
    })(),
    endDate: new Date(),
  });
  const [state, setState] = useState({ showModal: false,isOpenMenu:false,selectedCrew:null,selectedCat:null });
  const [rowData, setRowData] = useState([])
  const [vData, setVData] = useState([])
  const [itemMaster, setItemMaster] = useState([])
  const [selectedItems, setSelectedItems] = useState([])
  const [varianceData, setVarianceData] = useState([])
  const [isLoading, setIsLoading] = useState(false)
  const [chartData, setChartData] = useState([])
  const [chartData2, setChartData2] = useState([])

  const { hasPermission: viewInvReconDetails } = usePermissions('viewDetails', "inventory-reconciliation");

  useEffect(() => {
    fetchVariance()
    getMasterItems();
  }, [])

  useEffect(() => {
    if(itemMaster.length === 0 && varianceData.length === 0) return;
    formatVarianceJson()
  }, [varianceData])

  useEffect(() => {
    if(!state.selectedCrew || !state.selectedCat) return;
    const data = vData.find(data=>data.crewId === state.selectedCrew)
    if(data.groupDetails){
      const items = data.groupDetails.filter(item=>item.productCat === state.selectedCat)
      setSelectedItems([...items])
    }
  }, [state.selectedCrew,state.selectedCat])

  useEffect(() => {
    fetchVariance()
  }, [filterData])


async function getMasterItems(){
    try {
      const initialRes = await fetchItemMaster(1, 1);
      if (initialRes?.count && Array.isArray(initialRes.items) && initialRes.items.length) {
        const fullRes = await fetchItemMaster(1, initialRes.count);
        if (fullRes?.items?.length) {
          setItemMaster((_)=>[..._,...fullRes?.items]);
        }
      }
    } catch (error) {
      console.error("Failed to load:", error);
    }

}
  async function fetchItemMaster(pg,pgLimit) {
    filters.page=pg;
    if (pgLimit !== undefined && pgLimit !== null) {
      filters.limit = pgLimit;
    }
    try {
      const res = await APIEndpoint.post("master/process",JSON.stringify(filters))
      return res;
    } catch (error) {
      console.log(error)
    }
  }

  async function fetchVariance(){
    try {
      setIsLoading(true)
      const body = {...filterData}
      body.startDate = formatDateByTimezone(filterData.startDate)
      body.endDate = formatDateByTimezone(filterData.endDate)
      const res = await APIEndpoint.post("groups/variance",body)
      setIsLoading(false)
      setVarianceData(res.groups)
    } catch (error) {
      setIsLoading(false)
      console.log(error)
    }
  }

  function formatVarianceJson() {
    const formatted = varianceData.map(((group)=>{
      const data = {
        aoc:"",
        flightDate:getFlightData(group.sectors,"flightDate"),
        flightNumber:getFlightData(group.sectors,"flightNum"),
        sectorPairing:getFlightData(group.sectors,"flightSector"),
        crewId:group.key,
        groupDetails:formatItems([...group.items])
      }
      return data
    }))
    const formatted2 = varianceData.map(((group)=>{
      const data = {
        aoc:"",
        flightDate:getFlightData(group.sectors,"flightDate"),
        flightNumber:getFlightData(group.sectors,"flightNum"),
        sectorPairing:getFlightData(group.sectors,"flightSector"),
        crewId:group.key,
        groupDetails:formatItems([...group.items],true)
      }
      return data
    }))

    const groupedData = []
    formatted.forEach((data)=>{
        groupedData.push(data.groupDetails)
    })
    const chartData = groupAndSum(groupedData)
    setChartData(chartData)
    const chartDataRight = []

    formatted.forEach(data=>{
      chartDataRight.push({
        sector:data.sectorPairing,
        varianceData:getSumOfVariance(data.groupDetails)
      })
    })

    setChartData2([...chartDataRight])
    setVData([...formatted2])
    setRowData([...formatted])
  }

  function formatItems(items,groupBy=false){
    const itemsModified = items.map(item=>{
      const master = itemMaster.find(master=>master?.itemId===item?.itemId)
      return {...item,productCat:master?.category}
    })
    if(groupBy){
      return [...itemsModified]
    }
    let groupedData = {};
    itemsModified.forEach(item => {
      const { productCat, uplift, sales, wastage, offload, retrieval, variance, estimatedMeal, crewHandover,itemPice } = item;
      if (!groupedData[productCat]) {
        groupedData[productCat] = {itemCategory: productCat,estCount: 0,upliftCount: 0,salesCount: 0,wastageCount: 0,offloadCount: 0,crewHCount: 0,retrievelCount: 0,varianceCount: 0,varienceValue:0};
      }
      groupedData[productCat].upliftCount += uplift;
      groupedData[productCat].salesCount += sales;
      groupedData[productCat].wastageCount += wastage;
      groupedData[productCat].offloadCount += offload;
      groupedData[productCat].retrievelCount += retrieval;
      groupedData[productCat].varianceCount += variance;
      groupedData[productCat].varienceValue += itemPice ? itemPice*variance:variance*1;
      groupedData[productCat].estCount += estimatedMeal;
      groupedData[productCat].crewHCount += crewHandover;
    });
    const result = Object.values(groupedData);
    return result;
  }

  function groupAndSum(arrays) {
    return arrays.flat().reduce((acc, item) => {
        const { itemCategory, ...counts } = item;

        if (!acc[itemCategory]) {
            acc[itemCategory] = { itemCategory, ...counts };
        } else {
            for (const key in counts) {
                acc[itemCategory][key] = (acc[itemCategory][key] || 0) + (counts[key] || 0);
            }
        }

        return acc;
    }, {});
}

function getSumOfVariance(array) {
  return array.reduce(
    (acc, curr) => {
        acc.varianceCount += curr.varianceCount;
        acc.varienceValue += curr.varienceValue;
        return acc;
    },
    { varianceCount: 0, varienceValue: 0 }
);
}

  function getFlightData(sectors,dataType){
    if(dataType === "flightDate"){
      const flightDates = sectors.map(sector=>sector.flightDate).join(" | ");
      return flightDates;
    }else if(dataType === "flightNum"){
      const flightNumbers = sectors.map(sector=>sector.flightNumber).join(" | ");
      return flightNumbers;
    }else if(dataType === "flightSector"){
      const sectorPairs = sectors.map(sector=>`${sector.flightNumber}-${sector.origin}-${sector.destination}`).join(" | ");
      return truncateString(sectorPairs,30,true);
    }
  }

  const handleInputChange = (e) => {
    let { name, value } = e.target;
    if (name === "startDate") {
      let dataVal = getDateFromTimezone(value).toDate();
      setFilterData((prev) => {
        return { ...prev, startDate: dataVal };
      });
    }
    if (name === "endDate") {
      let dataVal = getDateFromTimezone(value).toDate();
      setFilterData((prev) => {
        return { ...prev, endDate: dataVal };
      });
    }
    setFilterData((prev) => {
      return { ...prev, [name]: value };
    });
  };

  const onClose = () => {
    setState(prev=>({...prev,selectedCrew:null}))
  };

 

  const Columns = [
    { field: "flightDate", headerName: "Flight Date",minWidth:150,flex:1, },
    { field: "flightNumber", headerName: "Flight Number",minWidth:150,flex:1, },
    { field: "sectorPairing", headerName: "Sector Pairing",minWidth:300,flex:1, },
    { field: "crewId", headerName: "Crew ID",minWidth:150,flex:1, },
  ];

 
  function fetchFilterStatus(){
    if(!Object.values(filterData).length)return;
  }
  return (
    <>
      <div className="flexCol full-flex ag-theme-alpine-dark">
      <div
          className="flex flexRow alignItemsCenter"
        >
       
      {fetchFilterStatus()?<><div className='felxCol m-2'>
            <Input
              label="Start Date"
              type="date"
              value={filterData.startDate}
              name="startDate"
              onChange={handleInputChange}
            />
          </div>
          <div className='felxCol m-2'>
            <Input
              label="End Date"
              type="date"
              value={filterData.endDate}
              name="endDate"
              onChange={handleInputChange}
            />
          </div></> :<></>}
       
        </div>
        <div style={{height:"70vh",overflowY:"auto"}}>
          <div className="cardViewToggler">
            <IrTopCards chartData={chartData} chartData2={chartData2}/>
          </div>
          <div style={{position:"relative"}}>

              <ExpandableTable
                columns={Columns}
                data={rowData}
                childTableHeadings={itemTableHead}
                setState={setState}
                isLoading={isLoading}
              />
            {/* )} */}
          </div>
        </div>
      </div>
      { state.selectedCrew && viewInvReconDetails &&(
        <EditModal showDone={false} onClose={onClose} title={`Item Details - ${state.selectedCrew} - ${state.selectedCat}`}>
          <div className="sm-scrollbar width100" style={{height:"40vh"}}>
            <table id="groupedItemTbl">
              <thead>
                <tr>
                  <th style={{width:"20%"}}>Item Name</th>
                  <th style={{width:"10%"}}>Est.Meal</th>
                  <th style={{width:"10%"}}>Crew.Verif</th>
                  <th style={{width:"10%"}}>Uplift</th>
                  <th style={{width:"10%"}}>Sales</th>
                  <th style={{width:"10%"}}>Wastage</th>
                  <th style={{width:"10%"}}>Offload</th>
                  <th style={{width:"10%"}}>Retrieval</th>
                  <th style={{width:"10%"}}>Variance</th>
                </tr>
              </thead>
              <tbody>
                {selectedItems.map((item,i)=>{
                  return (
                    <tr>
                      <td>{truncateString(item.itemName,18,true)}</td>
                      <td>{item.estimatedMeal}</td>
                      <td>{item.crewVerification}</td>
                      <td>{item.uplift}</td>
                      <td>{item.sales}</td>
                      <td>{item.wastage}</td>
                      <td>{item.offload}</td>
                      <td>{item.retrieval}</td>
                      <td>{item.variance}</td>
                    </tr>
                  )
                })}
              </tbody>
            </table>
          </div>
        </EditModal>
      )}
    </>
  );
};